import axios from 'axios';
import settings from './resources/settings.json';
import { getCookie } from './resources/utilities';


var url = settings.dev_server;
if (settings.environment === "production"){
    url = settings.prod_server;
}

export const fetchStockPrice = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockdata/${symbol}/1Y`);
    const data = await response.json();
        return data;
    };

export const fetchMFPrice = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/mf/${symbol}/`);
    const data = await response.json();
        return data;
    };



export const fetchStockLevels = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockdata/l/${symbol}/`);
    const data = await response.json();
        return data;
    };

export const fetchStockOITree = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockdata/oi/${symbol}/`);
    const data = await response.json();
        return data;
    };

export const fetchStockFundamentals = async (symbol,metric) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockdata/fd/${symbol}/${metric}`);
    const data = await response.json();
        return data;
    };


export const fetchStockTechnicals = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockdata/tasmall/${symbol}/`);
    const data = await response.json();
        return data;
    };

export const fetchStockRiskVol = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockdata/rva/${symbol}/`);
    const data = await response.json();
        return data;
    };

export const fetchStockOpsDerv = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockdata/op/${symbol}/`);
    const data = await response.json();
        return data;
    };

//export const fetchMarketIndices = async () => {
  // Replace with your actual API call
//    const response = await fetch(`${url}/api/market_indices/`);
//    const data = await response.json();
//        return data;
//    };

export const fetchMarketIndices = async (intraday = false) => {
  const response = await fetch(`${url}/api/market_indices/?intraday=${intraday}`);
  const data = await response.json();
  return data;
};

export const fetchMarketBreadth = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/market_breadth/`);
    const data = await response.json();
        return data;
    };

export const fetchSectorPerformance = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/sector_performance/`);
    const data = await response.json();
        return data;
    };

export const fetchMarketSentiment = async () => {
  // Replace with your actual API call
    console.log("Calling Market Sentiment")
    const response = await fetch(`${url}/api/market_sentiment/`);
    const data = await response.json();
        return data;
    };

export const fetchMacros = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/macros/`);
    const data = await response.json();
        return data;
    };
export const fetchMarketSructure = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/market_structure/`);
    const data = await response.json();
        return data;
    };
export const fetchTable = async (tablekind, symbol="") => {
    // Replace with your actual API call
    var api = "";

    if (tablekind == "ta") {
        api = "/api/stockdata/ta/"
        const response = await fetch(`${url}${api}${symbol}/`);
        const data = await response.json();
        // console.log("API  -> "+data);
        return data;
    }


    if (tablekind == "intraday_heatmap") {
        api = "/api/stockdata/intraday_heatmap/"
        const response = await fetch(`${url}${api}${symbol}/`);
        const data = await response.json();
        // console.log("API  -> "+data);
        return data;
    }

        if (tablekind == "intraday_pv") {
        api = "/api/stockdata/intraday_pv/"
        const response = await fetch(`${url}${api}${symbol}/`);
        // const data = await response.json();
        // console.log("API  -> "+data);
        // return data;
        return response;
    }

        if (tablekind == "intraday_vol") {
        api = "/api/stockdata/intraday_vol/"
        const response = await fetch(`${url}${api}${symbol}/`);
        const data = await response.json();
        return data;
        // return response;
    }


        if (tablekind == "intraday_vol_surge") {
        api = "/api/stockdata/intraday_vol_surge/"
        const response = await fetch(`${url}${api}${symbol}/`);
        const data = await response.json();
        console.log("VOL SURGE API  -> ",data);
        return data;
        // return response;
    }	


        if (tablekind == "intraday_momentum_vs_volatility") {
        api = "/api/stockdata/intraday_momentum_vs_volatility/"
        const response = await fetch(`${url}${api}${symbol}/`);
        const data = await response.json();
        console.log("VOL MOM API  -> ",data);
        return data;
        // return response;
    }
	if (tablekind == "st_macd") {
        api = "/api/ss/st_macd"
        const response = await fetch(`${url}${api}${symbol}/`);
        const data = await response.json();
        // console.log("API  -> "+data);
        return data;
    }
};

export const fetchPage = async (page, symbol="") => {
    // Replace with your actual API call
    var api = "";

    if (page == "stockpage") {
        api = "/api/stockpage/"
        const response = await fetch(`${url}${api}${symbol}/`);
        const data = await response.json();
        // console.log("API  -> "+data);
        return data;
    }

    if (page == "mfpage") {
        api = "/api/mf/"
        const apiurl = symbol === "" ? `${url}${api}` : `${url}${api}${symbol}/`;

        // console.log("API URL -> "+`${url}${api}${symbol}/`);
        const response = await fetch(`${apiurl}`);
        const data = await response.json();
        // console.log("API  -> "+data);
        return data;
    }

        if (page == "pfpage") {
        api = "/api/portfolio/"
        const apiurl = symbol === "" ? `${url}${api}` : `${url}${api}${symbol}/`;

        // console.log("API URL -> "+`${url}${api}${symbol}/`);
        const response = await fetch(`${apiurl}`);
        const data = await response.json();
        // console.log("API  -> "+data);
        return data;
    }
};


export const fetchNews = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/news/`);
    const data = await response.json();
        return data;
    };


export const fetchBlog = async () => {
  // Replace with your actual API call
  //   const response = await fetch(`${url}/api/posts/`);
    const response = await fetch(`${url}/api/blog/`);
    const data = await response.json();
        return data;
    };

export const fetchMarketCommentary = async () => {
  // Replace with your actual API call
  //   const response = await fetch(`${url}/api/posts/`);
    const response = await fetch(`${url}/api/market-commentary/latest/`);
    const data = await response.json();
        return data;
    };

export const fetchAnnouncements = async () => {
  // Replace with your actual API call
  //   const response = await fetch(`${url}/api/posts/`);
    const response = await fetch(`${url}/api/announcements/`);
    const data = await response.json();
        return data;
    };

export const contact = async (params) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/contact/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json", // Optional, if your server returns JSON
        },
        body: JSON.stringify(params)
    });
    const data = await response.json();
        return data;
    };


export const fetchScrollPrices = async () => {
  try {
    const response = await fetch(`${url}/api/scrollprices/`);
    const data = await response.json();
    return data; // API returns [{ symbol, last_price, change_percent }, ...]
  } catch (error) {
    console.error("Error fetching stock prices:", error);
    return [];
  }
};

export const fetchMarketOptions = async (symbol,mode="basic") => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/mops/${symbol}/${mode}`);
        const data = await response.json();
        return data;
};


export const fetchMarketMovers = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockmovers/${symbol}`);
    const data = await response.json();
    // console.log(data);
        return data;
    };

export const fetchMarketMovers_sparkline = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stockmovers_sparkline/${symbol}`);
    const data = await response.json();
    console.log('SPARKLINE API',data);
        return data;
    };

export const fetchRates = async (currency,params) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/rates/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json", // Optional, if your server returns JSON
            "X-CSRFToken": getCookie('csrftoken') // Retrieve CSRF token from cookies

        },
        body: JSON.stringify(params)
    });
    const data = await response.json();
        return data;
    };

export const fetchBonds = async (params) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/bonds/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json", // Optional, if your server returns JSON
            "X-CSRFToken": getCookie('csrftoken') // Retrieve CSRF token from cookies
        },
        body: JSON.stringify(params)
    });
    const data = await response.json();
        return data;
    };

export const fetchSecAnalysis = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/sec_anlys/`);
    const data = await response.json();
        return data;
    };

export const fetchStockPredict = async (symbol) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/stock_pred/${symbol}/`);
        const data = await response.json();
        return data;
};

export const fetchPortOptimize = async ({portfolio}) => {
     try {
        console.log('OPT API',portfolio)
        const response = await axios.post(
            `${url}/api/portopt/`,
              portfolio,
            {
                headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": getCookie('csrftoken') // Retrieve CSRF token from cookies
                    },
                // data: { portfolio: portfolio },
            }
        );
        const data = await response.data;
        return data;
    } catch (error) {
        console.error("Error getting optimization data:", error);
        throw error;
    }
};

//STRATEGIES

export const fetchStockStrategies = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/strategies/`);
        const data = await response.json();
        return data;
};

export const fetchStockStrategy = async (key) => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/strategies/${key}/`);
        const data = await response.json();
        return data;
};

export const runStrategy = async (key) => {
  // Replace with your actual API call
     try {
        console.log('RUN STRATEGY',key)
        const response = await axios.post(
            `${url}/api/run-strategy/`,
              key,
            {
                headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": getCookie('csrftoken') // Retrieve CSRF token from cookies
                    },
                // data: { portfolio: portfolio },
            }
        );
        const data = await response.data;
        return data;
    } catch (error) {
        console.error("Error getting strategy data:", error);
        throw error;
    }
};

export const fetchStockStrategyTags = async () => {
  // Replace with your actual API call
    const response = await fetch(`${url}/api/strategy-tags/`);
        const data = await response.json();
        return data;
};

// Payment APIs

export const upipayment = async (plan_id) => {
     try {
    const token = localStorage.getItem('authToken'); // Assuming you store token in localStorage
     // console.log("PLAN ID BEING SENT TO BACKEND",plan_id)
    const response = await axios.post(`${url}/api/payment/upi/`,
        {name: plan_id},
        {
            headers: {
                Authorization: `Bearer ${token}`,  // Pass the JWT token in Authorization header
                'Content-Type': 'application/json',
                "X-CSRFToken": getCookie('csrftoken') // Retrieve CSRF token from cookies
            },
            withCredentials: true
        });
    const data = await response.data;
    console.log('UPI DATA RECVD',data)
    return data;
    } catch (error) {
        console.error("Error getting payment data:", error);
        throw error;
    }
};


export const confirmPayment = async (payload) => {
  const token = localStorage.getItem("authToken");
  // const res = await axios.post("/api/payment/confirm-upi/", payload, {
  const res = await axios.post(`${url}/api/payment/confirm-upi/`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    "X-CSRFToken": getCookie('csrftoken') // Retrieve CSRF token from cookies
    },
    withCredentials: true
  });
  return res.data;
};



//Portfolio APIs

const createPortfolio = async (userId, portfolioName) => {
    const response = await axios.post('${url}/api/create_portfolio', {
        user_id: userId,
        portfolio_name: portfolioName,
    });
    return response.data;
};

const deletePortfolio = async (portfolioId, itemIds) => {
    const response = await axios.post('${url}/api/delete_portfolio_items', {
        portfolio_id: portfolioId,
        item_ids: itemIds
    });
    return response.data;
};
const fetchPortfolios = async (userId) => {
    const response = await axios.get(`/api/get_portfolios?user_id=${userId}`);
    const data = await response.json();
    return data;
    // setPortfolios(response.data.portfolios);
};
// export const fetchStockReturns = async (symbol) => {
//   // Replace with your actual API call
//   const response = await fetch(`https://api.example.com/returns?symbol=${symbol}&apikey=${apiKey}`);
//   const data = await response.json();
//   return data;
// };

// Other API functions...
